'use client'
import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { useLocale } from 'next-intl'
import { FlightSearchTabs as FlightSearchTabsComponent } from './flightSearchTabs'

interface FlightSearchTabsProps {
    isMobile: boolean
}

export const FlightSearchTabs = ({ isMobile }: FlightSearchTabsProps) => {
    const [tabValue, setTabValue] = useState(0)
    const locale = useLocale()

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        if (newValue === 1) {
            // Hotels tab - navigate to /hotel
            window.location.href = `https://www.flyin.com/${locale}/hotels`
        } else {
            // Flights tab - stay on current page
            setTabValue(newValue)
        }
    }

    return <FlightSearchTabsComponent tabValue={tabValue} onTabChange={handleTabChange} isMobile={isMobile} />
}
